import i18next from 'i18next'
import { ibanToBankMap, getMachedprefix } from '../../utils/IbanToBicMap'

export const getBankInfoFromIBAN = (iban: string): { bic: string; name: string } => {
  const cleanedIban = iban.replace(/\s/g, '')

  if (!cleanedIban.startsWith('FI') && !cleanedIban.startsWith('fi'))
    return {
      bic: i18next.t('unallocatedPaymentRefundFromDetails.bic.unknown'),
      name: i18next.t('unallocatedPaymentRefundFromDetails.bic.unknownBank')
    }
  const extractedPrefix = cleanedIban.slice(4, 7)

  const matchingKey = getMachedprefix(extractedPrefix)
  if (!matchingKey)
    return {
      bic: i18next.t('unallocatedPaymentRefundFromDetails.bic.unknown'),
      name: i18next.t('unallocatedPaymentRefundFromDetails.bic.unknownBank')
    }

  return ibanToBankMap[matchingKey]
}
